
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Users Components
// import { UsersComponent } from './users.component';
// import { LoginComponent } from './login/login.component';
// import { LandingComponent } from './landing/landing.component';
// import { TermsComponent } from './terms/terms.component';
// import { PrivacyComponent } from './privacy/privacy.component';
// import { UserResetrpasswordComponent } from './resetpassword/resetpassword.component';
// import { WallComponent } from './wall/wall.component';

//Common components

// import { HomeComponent } from './home/home.component';
// import { FooterComponent } from '../../common/footer.component';
// import { InterestComponent } from './interest/interest.component';
// import { SignupComponent } from './signup/signup.component';

const routes: Routes = [
    { 
      path: '',
      // component: LandingComponent,
      loadChildren: './landing/landing.module#LandingModule'
    },
    { 
      path: 'users/login',
      // component: LoginComponent
      loadChildren: './login/login.module#LoginModule' 
    },
    { 
      path: 'users/signup',
      // component: SignupComponent,
      loadChildren: './signup/signup.module#SignupModule'
    },
    { 
      path: 'users/home',
      // component: HomeComponent,
      loadChildren: './home/home.module#HomeModule'
    },
    { 
       path: 'users/interest',
       //component: InterestComponent,
       loadChildren: './interest/interest.module#InterestModule'
    },
    { 
        path: 'users/wall', 
        loadChildren: './wall/wall.module#WallModule'  
    },
    {   
        path: 'users/wall/:search', 
        loadChildren: './wall/wall.module#WallModule'
    },
    { 
       path: 'users/terms',
       loadChildren: './terms/terms.module#TermsModule'  
     },
     { 
        path: 'users/location', 
        loadChildren: './location/location.module#LocationModule' 
     },
     { 
          path: 'users/userdetail', 
          loadChildren: './account/account.module#AccountModule' 
      },
      { 
          path: 'users/settings', 
          loadChildren: './settings/settings.module#SettingsModule'
      },
      { 
        path: 'users/customizesegment',
        loadChildren: './customize-segment/customize-segment.module#CustomizeSegmentModule' 
      },
      { 
        path: 'users/updatepassword', 
        loadChildren: './updatepassword/updatepassword.module#UpdatepasswordModule'
      },
     { 
        path: 'users/deleteaccount', 
        loadChildren: './deleteaccount/deleteuseraccount.module#DeleteuseraccountModule'
     },
     { 
        path: 'users/resetpassword',
        loadChildren: './resetpassword/resetpassword.module#ResetpasswordModule'
      },
     { 
        path: 'users/resetconfirm/:key', 
        loadChildren: './userresetconfirm/userresetconfirm.module#ResetConfirmModule'
     }
    
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class UsersRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/users/users-routing.module.ts